import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import Logo from "components/Library/Logo";
import globalStyles from "styles/global.css";

import styles from "./LogoLink.css";

export default function LogoLink({ tabIndex }) {
  return (
    <a href="/" tabIndex={tabIndex} className={classNames(styles.root)}>
      <div className={styles.logoContainer}>
        <Logo isCompressed={true} />
        <h1 className={globalStyles.a11yOnly}>Axios</h1>
      </div>
    </a>
  );
}

LogoLink.defaultProps = {
  tabIndex: "0",
};

LogoLink.propTypes = {
  tabIndex: PropTypes.string,
};
